import { color, media,px2vw } from '@gyym/ui'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: ${color('black')};
  z-index: 0;
  height: ${px2vw(356 / 1.35, 480)};

  ${media.tablet} {
    height: ${px2vw(864 / 1.875, 'pc')};
  }
`

interface BaseImageSwapperProps {
  fadeIn: boolean
  fadeOut: boolean
}

export const BaseImageSwapper = styled.div<BaseImageSwapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;

  ${({ fadeIn }) =>
    fadeIn &&
    css`
      opacity: 1;
      transition: opacity 1s ease;
    `}

  ${({ fadeOut }) =>
    fadeOut &&
    css`
      z-index: -1;
      transition: opacity 0.1s ease 1s;
    `}
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
